import { ITypedReduxAction } from '../../../types/redux/actionType';
import { IArticlesMainDataSchema } from '../../../repositories/journal/entities/journal/ArticlesMainDataSchema';

export enum EGetMainArticlesActionType {
  Loading = 'mainArticles/getMainArticles/loading',
  Succeed = 'mainArticles/getMainArticles/succeed',
  AppendSucceed = 'mainArticles/getMainArticles/appendSucceed',
  Failed = 'mainArticles/getMainArticles/failed',
}

export type TGetMainArticlesLoading = ITypedReduxAction<EGetMainArticlesActionType.Loading>;
export type TGetMainArticlesSucceed = ITypedReduxAction<EGetMainArticlesActionType.Succeed, IArticlesMainDataSchema[]>;
export type TGetMainArticlesAppendSucceed = ITypedReduxAction<
  EGetMainArticlesActionType.AppendSucceed,
  IArticlesMainDataSchema[]
>;
export type TGetMainArticlesFailed = ITypedReduxAction<EGetMainArticlesActionType.Failed>;

export type TGetMainArticles =
  | TGetMainArticlesLoading
  | TGetMainArticlesSucceed
  | TGetMainArticlesAppendSucceed
  | TGetMainArticlesFailed;
